import StepBar2 from "../atoms/layout/StepBar2";
import SurveyContainer from "../atoms/layout/SurveyContainer";
import SurveyTitle from "../atoms/typography/Typography";
import Header from "../modules/layout/Header";
import AgreeForm from "../modules/application/AgreeForm";

const AgreeInsert = ({ visibility }) => {
  return (
    <div style={{ display: visibility }}>
      <Header />
      <SurveyContainer title="영어 말하기 평가">
        <div className="page-title text-align-center">
          <p>개인정보 동의서 · 전자서명</p>
        </div>
        <StepBar2 step={1} />
        <AgreeForm />
      </SurveyContainer>
    </div>
  );
};

export default AgreeInsert;
